import {Component, EventEmitter, Input, OnDestroy, OnInit, Output, QueryList} from '@angular/core';
import {Color, ColorPickerControl} from '@iplab/ngx-color-picker';

@Component({
  selector: 'app-custom-color-picker',
  templateUrl: './custom-color-picker.component.html',
  styleUrls: ['./custom-color-picker.component.css']
})
export class CustomColorPickerComponent implements OnInit {

  @Input()
  public id: string;
  // @Input()
  // public allPickers: QueryList<CustomColorPickerComponent>;

  public colorControl = new ColorPickerControl();

  public isVisible = false;

  public set color(color: string) {
    this.colorControl.setValueFrom(color);
  }

  @Output()
  public colorChange: EventEmitter<string> = new EventEmitter();

  @Output()
  public visibilityChange: EventEmitter<{ id: string; oldValue: boolean; newValue: boolean }> = new EventEmitter();

  public ngOnInit() {
    this.colorControl.hidePresets();
    this.colorControl.valueChanges.subscribe((value: Color) => {
      this.colorChange.emit(value.toHexString(true));
    });
  }

  public closeColorPicker() {
    this.isVisible = false;
  }

  public toggleColorPicker() {
    const oldValue: boolean = this.isVisible;
    this.isVisible = !this.isVisible;
    const newValue: boolean = this.isVisible;

    this.visibilityChange.emit({id: this.id, oldValue, newValue});
  }
}
